import { render } from "./Synology.vue?vue&type=template&id=521c198b"
import script from "./Synology.vue?vue&type=script&lang=ts"
export * from "./Synology.vue?vue&type=script&lang=ts"
script.render = render

export default script